//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import {PublicAppLayout} from 'app_components/layouts/public'
import BannerTextPrimaryCommon from 'app_components/commons/bannertextprimary'
import AllEventsModule from 'app_components/modules/newsEvents/allevents'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../alleventsScreen.scss'

// @ADD Component types
interface IAlleventsScreenLayoutProps {}

const AlleventsScreenLayout: React.FC<IAlleventsScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <PublicAppLayout>
      <div className="container">
        <BannerTextPrimaryCommon text={'Eventos'}/>
        <AllEventsModule/>
      </div>
    </PublicAppLayout>
  )
}

export default AlleventsScreenLayout
